export default __webpack_public_path__ + "static/media/(88).3a735ae8.jpg";